import { GridColumns } from '@mui/x-data-grid/models/colDef/gridColDef';
import { fnLocalizeFilter, ILocale } from '../../../../services/localize.service';
import { CellType, ct } from '../../../UI/Table/components/CellType/CellType';
import { ICards, IHolders } from '../../../../services/response.interface';
import { AppDispatch } from '../../../../store/store';
import { checkPermission } from '../../../../helpers/permissions';
import { IColumn } from '../../../UI/CustomTable/components/Columns/Columns';

export const getColumns1 = (locale: ILocale, theme: any): GridColumns => {

  const fnGetHeader = (key: string): string => {
    return fnLocalizeFilter(locale, key);
  };

  return [{
    field: 'numLine', headerName: fnGetHeader('_lang.module.common.table.num'), width: 50,
  }, {
    field: 'id',
    headerName: fnGetHeader('_lang.module.clientList.titleID'), width: 100, hide: true, sortable: true,
  }, {
    field: 'name',
    sortable: true,
    headerName: fnGetHeader('_lang.module.clientList.titleNameClient'),
    renderCell: ({ value }) => CellType({ type: ct.DEFAULT, value }),
    flex: 1,
  }, {
    field: 'okpo',
    sortable: true,
    headerName: fnGetHeader('_lang.module.clientList.titleOKPO'),
    renderCell: ({ value }) => CellType({ type: ct.DEFAULT, value }),
    width: 150,
    align: 'center',
    headerAlign: 'center',
  }, {
    field: 'itn',
    sortable: true,
    headerName: fnGetHeader('_lang.module.clientList.titleINN'),
    renderCell: ({ value }) => CellType({ type: ct.DEFAULT, value }),
    width: 150,
    align: 'center',
    headerAlign: 'center',
  }, {
    field: 'phone',
    sortable: true,
    headerName: fnGetHeader('_lang.module.clientList.titlePhone'),
    renderCell: ({ value }) => CellType({ type: ct.DEFAULT, value }),
    width: 150,
    align: 'center',
    headerAlign: 'center',
  }, {
    field: 'btnAccount',
    sortable: false,
    headerName: fnGetHeader('_lang.module.clientList.titleAccounts'),
    renderCell: ({ row }) => CellType({
      type: ct.LINK_HOVER, value: {
        title: fnGetHeader('_lang.module.clientList.titleAccounts'), link: `/clients/${row.id}/accounts`, style: {
          textDecoration: 'none', color: 'inherit',
        }, sx: {
          fontSize: 'inherit', opacity: '.5', '&:hover': {
            opacity: '1', color: theme.palette.secondary.main,
          },
        },
      },
    }),
    width: 150,
    align: 'center',
    headerAlign: 'center',
  }];
};

interface IGetColumns {
  locale: ILocale;
  holders: IHolders[];
  dispatch: AppDispatch;
}

export const getColumns = ({ locale, holders, dispatch }: IGetColumns): IColumn[] => {
  return [
    {
      field: 'id',
      label: fnLocalizeFilter(locale, '_lang.module.clientList.titleID'),
      formatHeader: 'default',
      cell: { format: 'default' },
      align: 'center',
      alignData: 'center',
      width: 50,
    },
    {
      field: 'name',
      label: fnLocalizeFilter(locale, '_lang.module.clientList.titleNameClient'),
      formatHeader: 'default',
      cell: { format: 'default' },
      align: 'left',
      alignData: 'left',
    },
    {
      field: 'okpo',
      label: fnLocalizeFilter(locale, '_lang.module.clientList.titleOKPO'),
      formatHeader: 'default',
      cell: { format: 'default' },
      align: 'center',
      alignData: 'center',
      width: 150,
    },
    {
      field: 'itn',
      label: fnLocalizeFilter(locale, '_lang.module.clientList.titleINN'),
      formatHeader: 'default',
      cell: { format: 'default' },
      align: 'center',
      alignData: 'center',
      width: 150,
    },
    {
      field: 'phone',
      label: fnLocalizeFilter(locale, '_lang.module.cards.titlePhone'),
      formatHeader: 'default',
      cell: { format: 'default' },
      align: 'center',
      alignData: 'center',
      width: 150,
    },
    {
      field: 'btnAccount',
      label: fnLocalizeFilter( locale, '_lang.module.clientList.titleAccounts' ),
      formatHeader: 'default',
      cell: { format: 'link-opacity-client', label: fnLocalizeFilter(locale, '_lang.module.clientList.titleAccounts') },
      align: 'center',
      alignData: 'center',
      width: 150,
    }
    ];
};
